import { toast } from "sonner";
import type { PricingVersion } from "@shared-core/data/pricing-admin-types";
import { Badge } from "../primitives/badge";

// Shared version-lifecycle bits for the registries and editors: there are no
// drafts — one Live version plus a revertable history of superseded ones.

export function liveVersion(
  versions: PricingVersion[],
): PricingVersion | undefined {
  return versions.find((v) => v.state === "live");
}

export function supersededVersions(
  versions: PricingVersion[],
): PricingVersion[] {
  return versions.filter((v) => v.state === "superseded");
}

/** The one-line "Live · v3 · 12 Jun · A. Patel · note" status. */
export function LiveVersionLine({ version }: { version: PricingVersion }) {
  return (
    <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-sm text-muted-foreground">
      <Badge variant="success">Live · v{version.v}</Badge>
      <span>
        {version.when} · {version.by}
      </span>
      {version.note && (
        <span className="text-muted-foreground/80">“{version.note}”</span>
      )}
    </div>
  );
}

/** The superseded-versions list with view / revert-to (revert is a mock toast). */
export function SupersededList({ versions }: { versions: PricingVersion[] }) {
  const superseded = supersededVersions(versions);
  if (superseded.length === 0) return null;
  return (
    <div className="space-y-1.5">
      {superseded.map((v) => (
        <div key={v.v} className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">
            v{v.v} · {v.range} · {v.by}
            {v.note && (
              <span className="text-muted-foreground/80"> · “{v.note}”</span>
            )}
          </span>
          <div className="flex items-center gap-3">
            <button
              className="text-primary hover:underline"
              onClick={(e) => e.stopPropagation()}
            >
              view
            </button>
            <button
              className="text-primary hover:underline"
              onClick={(e) => {
                e.stopPropagation();
                toast.success(`Reverted to v${v.v} — live now`);
              }}
            >
              revert to
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
